@if (exportList.length !== undefined) {
    <div class="grid">
      <field-tools class="col-12 md:col-3 lg:col-3" [dataTitle]="'ExportTitle' | translate">
        <div class="scroll-table">
          <p-listbox
            [options]="exportList"
            optionLabel="file_name"
            (onClick)="onExportClick($event)"
            [filter]="false"
            [listStyle]="{ width: '100%'}"
            [(ngModel)]="selectedItem"
            scrollHeight="75vh">
            <ng-template let-item pTemplate="item">
              <div [ngClass]="{'listbox-item-container': true, 'selected-item': selectedItem?.value === item.value}">                    
                  {{ item.name }}
              </div>
            </ng-template>
          </p-listbox>
        </div>
      </field-tools>
      @if (typeImpExp !=='') {
        <field-tools class="col-12 md:col-9 lg:col-9" [dataTitle]="'Display' | translate">
          <dm-fieldset-header [backGround]="false"></dm-fieldset-header>

          <div class="p-card w-full p-2 flex justify-content-between flex-wrap">
              <!-- Première div à gauche -->
              <div class="flex">
                  <div class="ml-2">
                      <p-fileUpload #fileUploader name="file"
                                    class="size_cent"
                                    mode="basic"
                                    [multiple]="false"
                                    [showUploadButton]="false"
                                    [showCancelButton]="false"
                                    chooseIcon="pi pi-upload"
                                    chooseLabel="{{'File_Sel_1' | translate}}"
                                    invalidFileTypeMessageSummary="{{'Imp_FileExt' | translate}}"
                                    invalidFileTypeMessageDetail=""
                                    accept=".json"
                                    (onSelect)="onFileSelect($event)">
                      </p-fileUpload>
                  </div>
                  <div class="ml-2 mt-auto mb-auto">
                      <p>{{filename}}</p>
                  </div>
                  @if (selectedRows.length !== 0) {
                    <div class="ml-2">
                      <p-button icon="pi pi-download" (onClick)="onClickImport()" label="{{'ImportAct' | translate}}"></p-button>
                    </div>                                      
                  }
              </div>
              <!-- Seconde div à droite -->
              <div class="flex ">
                  <div class="ml-2">
                      <p-button icon="pi pi-download" (onClick)="doExport(selectedItem.value)" label="{{'ExportAct' | translate}}"></p-button>
                  </div>
              </div>
          </div>
          @switch (true) {
            @case (typeImpExp === 'docks') {
              <p-table
                [value]="itemImport" 
                [(selection)]="selectedRows"
                selectionMode="multiple"
                class="width-100" 
                [columns]="listColumns">
                <ng-template pTemplate="caption">
                  <span class="header-grid-wrapper">
                  </span>              
                </ng-template>
                <ng-template let-columns pTemplate="header">
                  <tr>
                    <th class="width-col-3">
                      <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    @for (col of columns; track col.field; let i = $index) {
                      <th>
                        {{ col.header }}
                      </th> 
                    }               
                  </tr>
                </ng-template>
                <ng-template let-rowData let-rowIndex="rowIndex" let-columns="columns" pTemplate="body">
                  <tr [pSelectableRow]="rowData">
                    <td (click)="clickcolck($event)">
                      <p-tableCheckbox [value]="rowData" [index]="rowIndex"></p-tableCheckbox>
                    </td>
                    @for (col of columns; track col.field; let i = $index) {
                      <td class="width-auto">
                          @switch (col.field) {
                            @case ('docktype') {
                              @switch (rowData[col.field]) {
                                @case (0) {                              
                                  {{'Dck_Detail' | translate}}
                                }
                                @case (1) {
                                  {{'Dck_BMail' | translate}}
                                }
                                @case (2) {
                                  {{'Dck_BColl' | translate}}
                                }
                                @case (3) {
                                  {{'Dck_BAct' | translate}}
                                }       
                                @case (4) {
                                  {{'Dck_DMail' | translate}}
                                }                                                 
                                @case (5) {
                                  {{'Dck_RMail' | translate}}
                                }       
                                @case (6) {
                                  {{'Dck_VMail' | translate}}
                                }       
                                @case (7) {
                                  {{'Dck_VInvo' | translate}}
                                }                                                                      
                                @default {
                                  {{'Dck_Custom' | translate}}
                                }    
                              }
                            }
                            @default {
                              {{ rowData[col.field] }}
                            }
                          }
                      </td>
                    }
                  </tr>
                </ng-template>
              </p-table>              
            }
            @case ( typeImpExp === 'requests' || typeImpExp === 'results') {
              <p-table
                [value]="itemImport" 
                [(selection)]="selectedRows"
                selectionMode="multiple"
                class="width-100" 
                [columns]="listColumns">
                <ng-template pTemplate="caption">
                  <span class="header-grid-wrapper">
                  </span>              
                </ng-template>
                <ng-template let-columns pTemplate="header">
                  <tr>
                    <th class="width-col-3">
                      <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    @for (col of columns; track col.field; let i = $index) {
                      <th>
                        {{ col.header }}
                      </th> 
                    }               
                  </tr>
                </ng-template>
                <ng-template let-rowData let-rowIndex="rowIndex" let-columns="columns" pTemplate="body">
                  <tr [pSelectableRow]="rowData">
                    <td (click)="clickcolck($event)">
                      <p-tableCheckbox [value]="rowData" [index]="rowIndex"></p-tableCheckbox>
                    </td>
                    <td class="width-auto">
                      {{rowData[columns[0].field]}}
                    </td>
                    <td class="width-auto">
                      <visibility [value]="rowData[columns[1].field]"></visibility>
                    </td>
                    <td class="width-auto">
                      {{rowData[columns[2].field]}}
                    </td>
                  </tr>
                </ng-template>
              </p-table>  
            }
          }
        </field-tools>
      }
    </div>
  }
  
